/**
 * Enums para estados del sistema
 * Basado en la tabla de estados de la base de datos
 */

// Estados de Citas
export const ESTADOS_CITAS = {
  AGENDADA: {
    id: 1,
    nombre: 'Agendada',
    descripcion: 'Cita programada',
    color: 'bg-yellow-500'
  },
  CONFIRMADA: {
    id: 2,
    nombre: 'Confirmada',
    descripcion: 'Cita confirmada por el cliente',
    color: 'bg-blue-500'
  },
  PENDIENTE: {
    id: 1,
    nombre: 'Pendiente',
    descripcion: 'Cita pendiente',
    color: 'bg-yellow-500'
  },
  EN_PROCESO: {
    id: 3,
    nombre: 'En Proceso',
    descripcion: 'Cita en ejecución',
    color: 'bg-orange-500'
  },
  COMPLETADA: {
    id: 4,
    nombre: 'Completada',
    descripcion: 'Cita finalizada exitosamente',
    color: 'bg-green-500'
  },
  CANCELADA: {
    id: 5,
    nombre: 'Cancelada',
    descripcion: 'Cita cancelada',
    color: 'bg-red-500'
  },
  NO_ASISTIO: {
    id: 6,
    nombre: 'No Asistió',
    descripcion: 'Cliente no se presentó',
    color: 'bg-gray-500'
  }
};

// Estados de Vehículos
export const ESTADOS_VEHICULOS = {
  ACTIVO: {
    id: 7,
    nombre: 'Activo',
    descripcion: 'Vehículo activo',
    color: 'bg-green-500'
  },
  EN_MANTENIMIENTO: {
    id: 8,
    nombre: 'En Mantenimiento',
    descripcion: 'Vehículo en proceso de reparación',
    color: 'bg-orange-500'
  },
  FUERA_DE_SERVICIO: {
    id: 9,
    nombre: 'Fuera de Servicio',
    descripcion: 'Vehículo no operativo',
    color: 'bg-red-500'
  }
};

// Estados de Mantenimientos
export const ESTADOS_MANTENIMIENTOS = {
  PROGRAMADO: {
    id: 10,
    nombre: 'Programado',
    descripcion: 'Mantenimiento programado',
    color: 'bg-blue-500'
  },
  EN_EJECUCION: {
    id: 11,
    nombre: 'En Ejecución',
    descripcion: 'Mantenimiento en curso',
    color: 'bg-orange-500'
  },
  COMPLETADO: {
    id: 12,
    nombre: 'Completado',
    descripcion: 'Mantenimiento finalizado',
    color: 'bg-green-500'
  },
  PENDIENTE: {
    id: 13,
    nombre: 'Pendiente',
    descripcion: 'Mantenimiento pendiente',
    color: 'bg-yellow-500'
  }
};

// Funciones helper para obtener información de estados
export const getEstadoCitaById = (id) => {
  return Object.values(ESTADOS_CITAS).find(estado => estado.id === id);
};

export const getEstadoCitaByNombre = (nombre) => {
  return Object.values(ESTADOS_CITAS).find(estado => estado.nombre === nombre);
};

export const getEstadoVehiculoById = (id) => {
  return Object.values(ESTADOS_VEHICULOS).find(estado => estado.id === id);
};

export const getEstadoMantenimientoById = (id) => {
  return Object.values(ESTADOS_MANTENIMIENTOS).find(estado => estado.id === id);
};

// Función para obtener el color de un estado de cita
export const getColorEstadoCita = (estadoNombre) => {
  const estado = getEstadoCitaByNombre(estadoNombre);
  return estado ? estado.color : 'bg-gray-500';
};

// Lista de todos los estados de citas para selects/dropdowns
export const LISTA_ESTADOS_CITAS = Object.values(ESTADOS_CITAS);
export const LISTA_ESTADOS_VEHICULOS = Object.values(ESTADOS_VEHICULOS);
export const LISTA_ESTADOS_MANTENIMIENTOS = Object.values(ESTADOS_MANTENIMIENTOS);